<template>
  <v-app>
    <v-app-bar color="#293D75" dense dark flat app>
      <v-app-bar-nav-icon
        v-if="$route.name && $route.path.includes('admin')"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>

      <v-toolbar-title style="font-size: 30px;">
        <img
          class="mt-5 mb-5 mx-auto d-block logo"
          :src="logo"
          alt="PinPoint Logo"
        />
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <span v-if="isAuthenticated && loginDetails">
        <v-btn v-if="showDashboard" text :to="{ name: 'Dashboard' }">
          Dashboard
        </v-btn>
        <v-btn text @click="clearRecords()" :to="{ name: 'Records' }"
          >Records</v-btn
        >
        <span class="pl-8 name-menu">
          <v-btn
            small
            icon
            @click="userNotificationsDrawer = !userNotificationsDrawer"
          >
            <v-icon v-if="UserNotifications">mdi-bell</v-icon>
          </v-btn>
        </span>
        <span class="pl-8 name-menu">
          <v-btn small icon @click="messagingDrawer = !messagingDrawer">
            <v-icon>mdi-message</v-icon>
          </v-btn>
          <v-menu offset-y tile>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text v-bind="attrs" v-on="on">Hello {{ getName }}</v-btn>
            </template>
            <v-list class="name-menu">
              <v-list-item>
                <v-list-item-title>
                  <v-btn text @click="ShowProfile = !ShowProfile">
                    My Profile
                  </v-btn>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>
                  <v-btn text @click="logout">
                    Logout
                  </v-btn>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </span>
      </span>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" clipped app temporary>
      <sidebar-left></sidebar-left>
    </v-navigation-drawer>
    <v-navigation-drawer
      v-model="userNotificationsDrawer"
      right
      clipped
      app
      temporary
    >
      <v-card class="d-flex pa-2 justify-center">
        <v-btn
          v-if="showOnlyNewNotifications"
          @click="showOnlyNewNotifications = !showOnlyNewNotifications"
        >
          Show All
        </v-btn>
        <v-btn
          v-if="!showOnlyNewNotifications"
          @click="showOnlyNewNotifications = !showOnlyNewNotifications"
        >
          Show New
        </v-btn>
      </v-card>

      <v-card class="d-flex pa-2 justify-center">
        <h2 v-if="!UserNotifications[0]">No New Notifications</h2>
      </v-card>

      <v-card
        class="UserRecordNotification d-flex flex-column justify-md-space-between"
        v-for="(notification, index) of filteredUserNotifications"
        :key="notification._id"
      >
        <div>{{ notification.note }}</div>
        <v-card class="d-flex justify-end" elevation="0">
          <v-btn text @click="acknowledgeNotification(index, notification)">
            Acknowledge
          </v-btn>
        </v-card>
      </v-card>
    </v-navigation-drawer>
    <v-navigation-drawer
      v-model="messagingDrawer"
      v-if="loginDetails"
      width="1000"
      right
      clipped
      absolute
      temporary
      height="100%"
    >
      <messagingcenter />
    </v-navigation-drawer>
    <notificationslist />
    <ProfileCenter
      v-if="loginDetails"
      :openDrawer="ShowProfile"
      @input="setShowProfile($event)"
    />
    <v-main>
      <router-view :key="$route.fullPath"></router-view>
    </v-main>
  </v-app>
</template>
<script>
import { mapGetters, mapState, mapActions } from "vuex";
import SidebarLeft from "./components/Sidebar-Left";
import notificationslist from "./notifications/NotificationsList.vue";
import messagingcenter from "./records/components/messaging/MessageCenter.vue";
import ProfileCenter from "./user/Profile.vue";
import PinPointLogo from "../assets/RadectLogo.png";
import "../styles/variables.scss";

export default {
  name: "App",
  components: {
    SidebarLeft,
    notificationslist,
    messagingcenter,
    ProfileCenter
  },
  watch: {
    userNotificationsDrawer: function() {
      if (this.userNotificationsDrawer) {
        this.ShowProfile = false;
      }
    },
    messagingDrawer: function() {
      if (this.messagingDrawer) {
        this.ShowProfile = false;
      }
    }
  },
  data() {
    return {
      drawer: null,
      userNotificationsDrawer: false,
      messagingDrawer: false,
      showOnlyNewNotifications: true,
      logo: PinPointLogo,
      ShowProfile: false
    };
  },
  computed: {
    ...mapState({
      UserNotifications: state => state.records.UserRecordNotifications,
      currentlySelectedRecord: state => state.records.currentlySelectedRecord
    }),
    ...mapGetters({
      isAuthenticated: "isAuthenticated",
      isLoggedIn: "getToken",
      loginDetails: "getUser",
      roles: "getRoles",
      getName: "getLoggedInName"
    }),
    filteredUserNotifications: function() {
      if (
        this.showOnlyNewNotifications &&
        Array.isArray(this.UserNotifications)
      ) {
        return this.UserNotifications.filter(
          notification => notification.acknowledged === true
        );
      } else {
        //tests
        return this.UserNotifications;
      }
    },
    showDashboard() {
      return this.roles.includes("staff") || this.roles.includes("superuser");
    }
  },
  methods: {
    ...mapActions(["updateNotification"]),
    acknowledgeNotification(index, notification) {
      this.UserNotifications.splice(index, 1);
      notification.acknowledged = true;

      this.updateNotification(notification);
    },
    async logout() {
      await this.$store.dispatch("logoutUser");
      this.$router.push({ name: "Login" });
    },
    setShowProfile(value) {
      this.ShowProfile = value;
    },
    clearRecords() {
      this.$store.dispatch("ResetAllRecords");
    }
  }
};
</script>
<style lang="scss">
#app {
  font-family: $font-family;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: $primary-color;
  padding: 0;
}
#notificationslist {
  z-index: 1;
}
// Typography
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: $link-color;
}

// Forms
.level-1 {
  font-weight: bold;
  font-size: 24px;
}
.level-2 {
  font-weight: bold;
  font-size: 20px;
  text-decoration: underline;
  margin-top: 2em;
}
.level-3 {
  font-weight: bold;
  font-size: 16px;
}
.level-4 {
  font-style: italic;
  font-size: 16px;
}

// Loading
.loading {
  margin: 30px 0;
  text-align: center;
  color: #17a2bb;
}
.loading h2 {
  color: #17a2bb;
  margin: 0 0 10px;
  text-transform: uppercase;
  font-size: 18px;
}
.loading img {
  display: block;
  width: 160px;
  height: 24px;
  margin: 0 auto;
}

// Buttons
.create-new {
  display: block;
  width: 130px;
}

//notification
.UserRecordNotification {
  min-height: 150px;
  margin: 20px;
  border-radius: 8px;
}
.name-menu {
  .v-btn {
    text-transform: none;
    letter-spacing: normal;
    font-size: 1rem;
  }
}

.logo {
  max-height: 48px;
  max-width: 100%;
}
</style>
